import React from 'react';
import cnames from 'classnames';
import { CNAME, default as ValuePropsItem } from './ValuePropsItem';
import PropTypes from 'prop-types';
import { LockShield, LuggageGlobe, Tea, Currency } from './Icons/Icons';
import EdapModuleView from '../EdapModuleView';
import { MODULE_VIEW_EVENT_OPTIONS } from './events';

import './ValueProps.less';

const ValueProps = ({
  isTablet,
  safetyTitle,
  safetySubtitle,
  experienceTitle,
  experienceSubtitle,
  selelectionTitle,
  selectionSubtitle,
  valueTitle,
  valueSubtitle
}) => (
  <section className="Content__section">
    <EdapModuleView eventOptions={MODULE_VIEW_EVENT_OPTIONS}>
      <ul className={cnames(`${CNAME}__list`, 'row', 'app-wrapper', { 'app-wrapper--isTablet': isTablet })}>
        <ValuePropsItem icon={<LockShield />} title={safetyTitle} blurb={safetySubtitle} isTablet={isTablet} />
        <ValuePropsItem icon={<LuggageGlobe />} title={experienceTitle} blurb={experienceSubtitle} isTablet={isTablet} />
        <ValuePropsItem icon={<Tea />} title={selelectionTitle} blurb={selectionSubtitle} isTablet={isTablet} />
        <ValuePropsItem icon={<Currency />} title={valueTitle} blurb={valueSubtitle} isTablet={isTablet} />
      </ul>
    </EdapModuleView>
  </section>
);

ValueProps.propTypes = {
  isTablet: PropTypes.bool.isRequired
};

export default ValueProps;
